import waitForElement from './waitForElement';
import waitForCookie from './waitForCookie';
/**
 *
 * @param {String} waitFor Can be element or cookie
 * @param {Number} timeOutInMilliseconds how much time do you want to wait for the element
 * @param {Number} sleepInMillis frecuency to validate if the element exist already
 * @param {funcion} callBack function you want to run when the element is finded
 */
export default function wait(waitFor, ...args) {
  const actions = {
    cookie: waitForCookie,
    element: waitForElement,
  };

  if (typeof waitFor === 'string' && actions[waitFor]) {
    actions[waitFor](...args);
  }
}
